var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.61 28.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-10,.cls-11,.cls-12,.cls-9{opacity:0.3;mix-blend-mode:multiply;}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.71,
    y1: -10.91,
    x2: -1.84,
    y2: 24.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a92f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#674bef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 36.23,
    y1: -9.36,
    x2: -0.33,
    y2: 26.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 38.22,
    y1: -7.32,
    x2: 1.67,
    y2: 28.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 34.64,
    y1: -10.99,
    x2: -1.92,
    y2: 24.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 40.04,
    y1: -5.47,
    x2: 3.48,
    y2: 30.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 42.49,
    y1: -2.97,
    x2: 5.93,
    y2: 32.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 38,
    y1: -7.55,
    x2: 1.45,
    y2: 28.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -51.1,
    y1: -232.85,
    x2: -47.65,
    y2: -232.85,
    gradientTransform: "translate(67.33 253.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -51.1,
    y1: -245.9,
    x2: -47.65,
    y2: -245.9,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 7.78,
    y1: 11.86,
    x2: 7.78,
    y2: 8.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 7.78,
    y1: 16.74,
    x2: 7.78,
    y2: 19.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 37.34,
    y1: -8.23,
    x2: 0.78,
    y2: 27.53,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_circ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.93 6.63 8.93 21.98 6.63 19.68 6.63 8.93 6.63 8.93 8.93 6.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.84,11.82v.78a.75.75,0,0,1-.76.76H10.94V11.08h6.14a.75.75,0,0,1,.76.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.84,15.83v.77a.74.74,0,0,1-.76.75H10.94V15.07h6.14A.75.75,0,0,1,17.84,15.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "21.98 8.92 6.63 8.92 8.93 6.63 19.68 6.63 20.83 7.78 21.98 8.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "21.98 19.68 21.98 19.68 19.68 21.98 19.68 21.97 19.68 21.97 8.93 21.97 8.93 21.97 6.63 19.68 21.98 19.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "21.99 16.73 21.99 19.68 21.98 19.68 21.98 19.68 19.68 21.98 19.66 21.98 19.66 21.98 19.66 21.98 19.66 16.73 21.99 16.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "21.99 8.93 21.99 11.87 19.66 11.87 19.66 6.63 20.83 7.78 21.99 8.93"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 16.23,
    y: 19.68,
    width: 3.45,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 16.23,
    y: 6.63,
    width: 3.45,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 6.63,
    y: 8.92,
    width: 2.3,
    height: 2.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 6.63,
    y: 16.74,
    width: 2.3,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.3,28.61A14.31,14.31,0,1,1,28.61,14.3,14.32,14.32,0,0,1,14.3,28.61ZM14.3,1A13.31,13.31,0,1,0,27.61,14.3,13.32,13.32,0,0,0,14.3,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.55dfc1cbfc53678a8081ecf58be4fce3.svg";
export { ForwardRef as ReactComponent };